import React, { Component } from "react"
import Tour from "reactour"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import CookieConsent from "react-cookie-consent"
import { NamespacesConsumer as I18n } from "react-i18next"
import { isMobile } from "react-device-detect"
import LazyLoad from "react-lazyload"
import "./App.css"

//component
import { handlelocalstorageSetcookie } from "./containers/Registration/PostMessage"
import Footerarea from "./components/Footer_area"
import TermandPrivacy from "./containers/Registration/TermandPrivacy"
import Route from "./Route"
import { NotificationManage } from "./components/NotificationManage"
import { sizeofwindows } from "./containers/Function/App.function"
import NavBarDesktop from "./components/NavBarDesktop"
import NavBarMobile from "./components/NavBarMobile"
import { loadFacebookSDK } from "./containers/Function/App.function"
import { closeTutor } from "./actions/action_tour"
import { enableBodyScroll, disableBodyScroll } from "body-scroll-lock"
import * as notification_actions from "./actions/action_notification"

import Amplify from "aws-amplify"
import config from "./config"

const configAmplify = (user) => {
	if (!!user) {
		if (Object.keys(user).length === 0) {
			Amplify.configure({
				Auth: config.auth,
				aws_appsync_graphqlEndpoint: config.appsyncunAuth.graphqlEndpoint,
				aws_appsync_region: config.appsyncunAuth.region,
				aws_appsync_authenticationType: config.appsyncunAuth.authenticationType,
				aws_appsync_apiKey: config.appsyncunAuth.apiKey
			})
		} else {
			Amplify.configure({
				Auth: config.auth,
				aws_appsync_graphqlEndpoint: config.appsyncAuth.graphqlEndpoint,
				aws_appsync_region: config.appsyncAuth.region,
				aws_appsync_authenticationType: config.appsyncAuth.authenticationType,
				aws_appsync_apiKey: config.appsyncAuth.apiKey
			})
		}
	}
}
class App extends Component {
	constructor(props) {
		super(props)
		this.state = {
			hideNav: false,
			openTermand: false,
			statusgetnoti: true,
			isIE: /*@cc_on!@*/ false || !!document.documentMode
		}
	}
	componentDidMount() {
		configAmplify(this.props.user)
		loadFacebookSDK()
		window.addEventListener("resize", this.resize.bind(this))
		this.resize()
		const Lang = localStorage.getItem("Language")
		if (!Lang) {
			localStorage.setItem("Language", "en")
		}
		let routewindow = [
			"/ResendConfirmRegistration",
			"/Register",
			"/Login",
			"/ForgotPassword",
			"/Repassword",
			"/Restorename",
			"/Restorepassword"
		]
		let routemobile = ["/ResendConfirmRegistration", "/Register", "/Login"]
		if (this.state.hideNav) {
			let result = routemobile.find((item) => item === window.location.pathname)
			if (result !== undefined) {
				this.props.history.push("/")
			}
		} else {
			let result = routewindow.find((item) => item === window.location.pathname)
			if (result !== undefined) {
				this.props.history.push("/")
			}
		}
	}
	async UNSAFE_componentWillReceiveProps(nextProps) {
		configAmplify(nextProps.user)
		if (Object.keys(nextProps.user).length !== 0 && this.state.statusgetnoti) {
			await this.props.get_notification(nextProps.userInfo.user_id, null)
			this.setState({ statusgetnoti: false })
		}
		if (Object.keys(nextProps.user).length === 0) {
			await this.props.clear_notification()
			this.setState({ statusgetnoti: true })
		}
	}
	openprivacy = () => {
		this.setState({ openTermand: true })
	}
	closeprivacy = () => {
		this.setState({ openTermand: false })
	}
	resize() {
		this.setState({ hideNav: sizeofwindows("md") })
	}
	handleonmessage = () => {
		window.onmessage = function (e) {
			if (e.origin !== "https://blogs.mixedmodel.academy") {
				return
			}
			let payload = JSON.parse(e.data)
			switch (payload.method) {
				case "set":
					localStorage.setItem(payload.key, payload.data)
					break
				case "clear":
					localStorage.clear()
					localStorage.setItem("UsedCookie", "true")
					break
				default:
					break
			}
		}
	}
	render() {
		let { hideNav, openTermand, isIE } = this.state
		const { user } = this.props

		return (
			<I18n>
				{(t) => {
					return (
						<div>
							{hideNav === false ? (
								<div>
									{localStorage.getItem("UsedCookie") !== "true" ? (
										<CookieConsent
											onAccept={() => {
												handlelocalstorageSetcookie()
												NotificationManage(
													"success",
													`${t("NotificationManager.App.ThankYou")}`,
													`${t("NotificationManager.App.AcceptCookie")}`
												)
											}}
											onDecline={() => {
												NotificationManage(
													"success",
													`Title`,
													`You just decline`
												)
											}}
											debug={true}
											cookieName="UsedCookie"
											cookieValue={true}
											declineCookieValue={false}
											location={isIE ? "none" : "bottom"}
											buttonText={t("NotificationManager.App.ok")}
											declineButtonText="I decline"
											style={{
												background: "rgba(202, 250, 82, 0.9)",
												color: "black",
												fontSize: "1.125rem",
												height: "100px",
												padding: "10px",
												paddingRight: "10%",
												paddingLeft: "10%",
												bottom: isIE ? 70 : 0
											}}
											buttonStyle={{
												color: "#FFFFFF",
												fontSize: "15px",
												background: "#311b92",
												borderRadius: ".28571429rem",
												padding: "15px 35px",
												boxShadow:
													"0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)"
											}}
											expires={150}
										>
											{t("NotificationManager.App.By")}
											<span className="bannercookie">
												<a
													aria-label="europa"
													className="span_Privacy"
													href="http://ec.europa.eu/ipg/basics/legal/cookies/index_en.htm"
													target="_blank"
													rel="noopener noreferrer"
												>
													&nbsp; {t("NotificationManager.App.want")}
												</a>

												<span
													className="span_Privacy"
													onClick={() => this.openprivacy()}
												>
													&nbsp;{t("NotificationManager.App.Privacy")}
												</span>
											</span>
										</CookieConsent>
									) : (
										<div />
									)}
									{isIE && (
										<div
											className="bannerTopIE"
											style={{
												position: "fixed"
											}}
										>
											More features and functions available on Chrome or Firefox
										</div>
									)}
									<LazyLoad height={200}>
										<NavBarDesktop history={this.props.history} />
									</LazyLoad>
									<Tour
										steps={this.props.tour}
										isOpen={this.props.open_tour}
										onRequestClose={() => this.props.closeTutor()}
										rounded={5}
										accentColor={"#5cb7b7"}
										onAfterOpen={(target) => disableBodyScroll(target)}
										onBeforeClose={(target) => enableBodyScroll(target)}
										startAt={0}
									/>
									<Route />
									<Footerarea user={user} />
								</div>
							) : (
								<div>
									{localStorage.getItem("UsedCookie") !== "true" ? (
										<CookieConsent
											onAccept={() => {
												handlelocalstorageSetcookie()
												NotificationManage(
													"success",
													`${t("NotificationManager.App.ThankYou")}`,
													`${t("NotificationManager.App.AcceptCookie")}`
												)
											}}
											onDecline={() => {
												NotificationManage(
													"success",
													`Title`,
													`You just decline`
												)
											}}
											debug={true}
											// acceptOnScroll={true}
											cookieName="UsedCookie"
											cookieValue={true}
											declineCookieValue={false}
											location="bottom"
											buttonText={t("NotificationManager.App.ok")}
											declineButtonText="I decline"
											style={{
												display: "block",
												background: "rgba(202, 250, 82,0.9)",
												color: "black",
												fontSize: "1.125rem",
												paddingRight: "5%",
												paddingLeft: "5%"
											}}
											buttonStyle={{
												color: "rgba(255,255,255)",
												fontSize: "15px",
												background: "#311b92",
												borderRadius: ".28571429rem",
												padding: "15px 35px",
												boxShadow:
													"0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)"
											}}
											expires={150}
										>
											{t("NotificationManager.App.By")}
											<span className="bannercookie">
												<a
													aria-label="europa"
													className="span_Privacy"
													href="http://ec.europa.eu/ipg/basics/legal/cookies/index_en.htm"
													target="_blank"
													rel="noopener noreferrer"
												>
													&nbsp; {t("NotificationManager.App.want")}
												</a>

												<span
													className="span_Privacy"
													onClick={() => this.openprivacy()}
												>
													&nbsp;{t("NotificationManager.App.Privacy")}
												</span>
											</span>
										</CookieConsent>
									) : (
										<div
											className="bannerTop"
											style={{
												position: "fixed"
											}}
										>
											{isMobile ? (
												<p className="TAGP">
													More features and functions available on PC
												</p>
											) : (
												<p className="TAGP">
													More features and functions available on wider screen
												</p>
											)}
										</div>
									)}

									<NavBarMobile />
								</div>
							)}
							<TermandPrivacy
								t={t}
								Open={openTermand}
								handleClickClose={this.closeprivacy}
							/>
							<iframe
								title="helperFrame"
								style={{ display: "none" }}
								id="helperFrame"
								src="https://blogs.mixedmodel.academy"
							>
								{this.handleonmessage()}
							</iframe>
						</div>
					)
				}}
			</I18n>
		)
	}
}
function mapStateToProps(reduxState) {
	return {
		user: reduxState.UserReducer.user,
		userInfo: reduxState.UserReducer.userInfo,
		open_tour: reduxState.TourReducer.isOpen,
		tour: reduxState.TourReducer.tour
	}
}
const mapDispatchToProps = function (dispatch, ownProps) {
	return {
		closeTutor: () => dispatch(closeTutor()),
		get_notification: (user_id, next_token) =>
			dispatch(notification_actions.get_notification(user_id, next_token)),
		clear_notification: () =>
			dispatch(notification_actions.clear_notification())
	}
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))
